import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import * as FundingRequestsEntityConfig from './EntityConfig';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as FundingRequestRoute } from '~/core/routes/funding-requests/[fundingRequestId]/_index';
import { Route as FundingRequestsRoute } from '~/core/routes/funding-requests/_index';
import { Route as FundingRequestCreateRoute } from '~/core/routes/funding-requests/create/_index';
import { Route as FundingRequestUpsizeRoute } from '~/core/routes/funding-requests/upsize/_index';
import { Router as VerificationsRouter } from '~/core/routes/funding-requests/verifications/Router';
import { CreditFacilityProvider } from '~/packages/credit-facility/hooks/CreditFacilityProvider';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={FundingRequestsEntityConfig.permissions}
      fallback={<Navigate to="/" replace />}
    >
      <CreditFacilityProvider>
        <Outlet />
      </CreditFacilityProvider>
    </PermissionGuard>
  ),
  // Relative to /funding-requests/*
  children: [
    { index: true, element: <FundingRequestsRoute /> },
    { path: 'create', element: <FundingRequestCreateRoute /> },
    { path: 'upsize', element: <FundingRequestUpsizeRoute /> },
    { path: ':fundingRequestId', element: <FundingRequestRoute /> },
    { path: 'verifications/*', children: [VerificationsRouter] },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
